import { API_URL, ASSETS, URL, PLATFORM_FEE } from '../config.js';
import { printdDate } from '../helper.js';
import View from './View';

class disclaimerView extends View {
  _parentElement = document.querySelector('.main');
  _errorMessage = 'Disclaimer View Error Message';
  _message = 'Disclaimer View Success Message';

  _generateMarkup() {
    return `
              <div class="row disclaimer">
        <h1 class="heading__static">Disclaimer</h1>
        <p class="paragraph">
          All the products/pictures of products available here are only for
          demonstration purpose and may defer from the actual delivered product.
          Pagya Enterprises shall not be responsible for the same. Any mistake,
          error or discrepancy noted may be brought to our notice which shall be
          taken care of and will be definitely resolved as soon as possible. It
          is notified that Pagya Enterprises will not be responsible for any
          damage or loss of action of anyone, of any kind, in any manner,
          therefrom.
        </p>
      </div>
    `;
  }
}

export default new disclaimerView();
